import { render, staticRenderFns } from "./AppDashboard.vue?vue&type=template&id=90dd4d54&scoped=true&"
import script from "./AppDashboard.vue?vue&type=script&lang=ts&"
export * from "./AppDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./AppDashboard.vue?vue&type=style&index=0&id=90dd4d54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90dd4d54",
  null
  
)

export default component.exports